module.exports = __webpack_public_path__ + "img/015.35cdda2e.jpg";